import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import { ProgressBar } from '@verclam/ui-kit';

const rowStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.375rem;
`;

const headerStyle = css`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	gap: 1rem;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.semibold};
	color: ${theme.colors.ink};
`;

const amountStyle = css`
	font-family: ${theme.fonts.mono};
`;

const detailStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkMuted};
`;

const barStyle = { height: '8px' };

type Props = {
	readonly label: string;
	readonly amount: string;
	readonly percent: number;
	readonly color: string;
	/** Ink of the amount. */
	readonly ink: string;
	readonly detail: string;
};

const SplitRow: React.FC<Props> = ({ label, amount, percent, color, ink, detail }) => {
	return (
		<div css={rowStyle}>
			<div css={headerStyle}>
				<span>{label}</span>
				<span css={amountStyle} style={{ color: ink }}>
					{amount}
				</span>
			</div>
			<ProgressBar
				value={percent}
				showValue={false}
				color={color}
				style={barStyle}
				aria-label={`${label} : ${Math.round(percent)} % du total`}
			/>
			<p css={detailStyle}>{detail}</p>
		</div>
	);
};

export default SplitRow;
